export default "__VITE_ASSET__BE5kA22v__"